import React from 'react'
import Link from 'gatsby-link'
import Logo from '../images/phanorcoll-logo.png'

const Header = ({ siteTitle }) => (
  <header className="header">
    <Link to="/" className="logo">
      <img src={Logo} alt="Phanor Coll" />
    </Link>
    <input className="menu-btn" type="checkbox" id="menu-btn" />
    <label className="menu-icon" htmlFor="menu-btn">
      <span className="navicon" />
    </label>
    <ul className="menu">
      <li>
        <Link to="/">Home</Link>
      </li>
      <li>
        <Link to="/about" activeClassName="active">
          About
        </Link>
      </li>
      <li>
        <Link to="/lab" activeClassName="active">
          lab
        </Link>
      </li>
      <li>
        <Link to="/library" activeClassName="active">
          Library
        </Link>
      </li>
      <li>
        <Link to="/hands-on-gatsbyjs" activeClassName="active">
          Gatsbyjs
        </Link>
      </li>
      <li>
        <Link to="/contact" activeClassName="active">
          contact
        </Link>
      </li>
    </ul>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js